"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const globalStyle_1 = __importDefault(require("../../style/globalStyle"));
exports.default = {
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center'
    },
    title: {
        fontSize: 14,
        fontWeight: 700,
        lineHeight: '18px',
        color: globalStyle_1.default.grey1
    }
};
//# sourceMappingURL=viewTitle.styles.js.map